// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const seaking: PokeData = {
  "id": 119,
  "name": "seaking",
  "height": 13,
  "weight": 390,
  "base_experience": 158,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "horn-attack",
    "fury-attack",
    "horn-drill",
    "tail-whip",
    "supersonic",
    "psybeam",
    "peck",
    "agility",
    "quick-attack",
    "waterfall",
    "skull-bash",
    "flail",
    "megahorn",
    "water-sport",
    "water-pulse",
    "aqua-ring",
    "poison-jab",
    "soak"
  ],
  "moves": [
    "supersonic",
    "peck",
    "quick-attack",
    "poison-jab",
    "water-spout",
    "hydro-pump",
    "life-dew",
    "rain-dance",
    "bubble",
    "whirlpool",
    "aqua-cutter",
    "aqua-tail",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 55,
    "item": null,
    "species": [
      {
        "name": "goldeen",
        "order": 135,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "seaking",
        "order": 136,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 118,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 115,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
